import { PreviewFile } from '@billy/design-system'
import { useTheme } from 'emotion-theming'
import React, { ComponentProps, ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Theme } from '../../../types/theme'
import { Text } from '../../Typography'
import { Container as AbsoluteContainer } from '../Container'
import { Files } from './Files'
import * as Styled from './styles'

export type FormFilesLayoutProps = {
  children: ReactNode
  files?: PreviewFile[]
  loading?: boolean
  ref?: ComponentProps<typeof Styled.MainContainer>['ref']
}

export const FormFilesLayoutBox = Styled.FormFilesLayoutBox

export const FormFilesLayout = ({ children, files = [], loading, ...rest }: FormFilesLayoutProps): ReactElement => {
  const { t } = useTranslation()
  const theme = useTheme<Theme>()

  const renderLoadingOverlay = () => (
    <Styled.LoadingContainer theme={theme}>
      <Text>{t('loading')}</Text>
    </Styled.LoadingContainer>
  )

  return (
    <Styled.MainContainer {...rest}>
      <AbsoluteContainer>
        {loading && renderLoadingOverlay()}

        <Styled.FormFileStackLayout>
          {/* Form side */}
          <Styled.FormContainer direction="vertical">
            <Styled.FormAbsoluteContainer>{children}</Styled.FormAbsoluteContainer>
          </Styled.FormContainer>

          {/* Files side */}
          <Styled.FilesContainer>
            <Styled.FilesAbsoluteContainer>
              <Files files={files} isLoading={!!loading} />
            </Styled.FilesAbsoluteContainer>
          </Styled.FilesContainer>
        </Styled.FormFileStackLayout>
      </AbsoluteContainer>
    </Styled.MainContainer>
  )
}
